'use client'

import { Loader2 } from 'lucide-react'
import { useTranslations } from 'next-intl'
import Snowfall from '@/components/snowfall'
import { BRAND_GRADIENT } from '@/lib/brand'

interface LoadingScreenProps {
  /** Main message to display */
  message?: string
  /** Secondary message below the main one */
  submessage?: string
}

/**
 * Full-screen Christmas-themed loading component
 * Used across the app for consistent loading experience
 */
export function LoadingScreen({ 
  message, 
  submessage 
}: LoadingScreenProps) {
  const t = useTranslations('common.loading')
  const displayMessage = message || t('default')
  return (
    <div className={`relative min-h-screen overflow-hidden ${BRAND_GRADIENT}`}>
      <Snowfall />
      
      {/* Glow accents */}
      <div className="pointer-events-none absolute inset-0 opacity-30">
        <div className="absolute -left-24 top-10 h-72 w-72 rounded-full bg-amber-400 blur-[120px]" />
        <div className="absolute -right-24 bottom-10 h-80 w-80 rounded-full bg-emerald-400 blur-[140px]" />
      </div>

      <div className="relative z-10 flex min-h-screen flex-col items-center justify-center p-6">
        <div className="flex flex-col items-center justify-center space-y-6 p-8">
          <div className="relative">
            <div className="absolute inset-0 rounded-full bg-white/20 blur-xl animate-pulse" />
            <div className="relative p-6 bg-white/10 backdrop-blur-sm rounded-full border border-white/20">
              <Loader2 className="h-12 w-12 animate-spin text-amber-300" />
            </div>
          </div>
          <p className="text-xl text-white/90 font-christmas">
            {displayMessage}
          </p>
          {submessage && (
            <p className="text-sm text-white/60">
              {submessage}
            </p>
          )}
        </div>
      </div>
    </div>
  )
}









